var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-modal',{ref:"messageIndex",attrs:{"title":_vm.$t('Messages'),"hide-footer":"","centered":"","scrollable":"","body-class":"p-0","no-close-on-esc":"","static":""},model:{value:(_vm.modal),callback:function ($$v) {_vm.modal=$$v},expression:"modal"}},[_c('message-inbox')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }